import { quartersAvailable } from '@app/invoicing/constants/invoice.constants';
import { PerUnitOfTime } from '@app/shared/enums/per-unit-time.enum';
import { DateUtils } from '@smooved/core';

export const startFromQuarterForAdmin = DateUtils.tz().year(2020).quarter(4).startOf(PerUnitOfTime.Quarter);
export const startFromQuarter = DateUtils.tz().subtract(quartersAvailable, PerUnitOfTime.Quarter).startOf(PerUnitOfTime.Quarter);
